// HappyFox's dashboard payload uses lowercase dates, sometimes wrapped by BigQuery.
export function ticketText(value, fallback = '—') {
    return (
        (typeof value === 'string' && value.trim()) ||
        (typeof value === 'number' && Number.isFinite(value) ? String(value) : fallback)
    )
}

export function ticketTimestamp(value) {
    const raw = value && typeof value === 'object' ? value.value : value
    if ((typeof raw !== 'string' && typeof raw !== 'number') || raw === '') return null
    const time = new Date(raw).getTime()
    return Number.isFinite(time) ? time : null
}

export function formatTicketDate(value) {
    const time = ticketTimestamp(value)
    return time === null
        ? 'Date unavailable'
        : new Date(time).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function ticketStatusTone(value) {
    const status = ticketText(value, '').toLowerCase()
    if (!status || status === 'unknown') return 'neutral'
    return ['closed', 'resolved'].includes(status) ? 'green' : 'orange'
}

export function normalizeTickets(data) {
    if (!Array.isArray(data) || data.some((ticket) => !ticket || typeof ticket !== 'object' || Array.isArray(ticket))) {
        throw new Error('Invalid support tickets response')
    }
    const occurrences = new Map()
    return data.map((ticket) => {
        const key = ticketText(
            ticket.ticketId,
            JSON.stringify([
                ticketText(ticket.subject, ''),
                ticketTimestamp(ticket.createdat),
                ticketText(ticket.status, '')
            ])
        )
        const occurrence = occurrences.get(key) || 0
        occurrences.set(key, occurrence + 1)
        return { ...ticket, id: `${key}:${occurrence}` }
    })
}
